export function isKeyOfObject(key, obj) {
    return key in obj;
}
